import { FC } from "react";
import { Check } from "phosphor-react"; // Opcional: Si quieres mostrar palomita en pasos completados

interface StepProps {
  number: number;
  label: string;
  isActive: boolean;
  // Opcional: podrías agregar isCompleted si quisieras marcar los pasos anteriores
}

const Step: FC<StepProps> = ({ number, label, isActive }) => {
  return (
    <div className="flex flex-col items-center relative z-10">
      {/* Círculo */}
      <div
        className={`
          w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 border-2
          ${isActive
            ? "bg-[#84cc16] border-[#84cc16] text-white shadow-[0_0_0_4px_rgba(132,204,22,0.2)]" // Activo: Verde, borde verde, sombra suave
            : "bg-white border-slate-300 text-slate-400" // Inactivo: Blanco, borde gris
          }
        `}
      >
        {number}
      </div>

      {/* Etiqueta (Texto abajo) */}
      <span
        className={`
          text-[10px] font-bold uppercase tracking-wider mt-2 transition-colors duration-300 absolute -bottom-6 w-max text-center
          ${isActive ? "text-[#84cc16]" : "text-slate-400"}
        `}
      >
        {label}
      </span>
    </div>
  );
};

export default Step;